import React, { useEffect, useState } from "react";
import Workordersummary from "./Workordersummary";
import Issuesinorder from "./Issuesinorder";
import Vehicleservicetasks from "./Vehicleservicetasks";
import Vehicleservicepartdetails from "./Vehicleservicepartdetails";
import Insurance from "./Insurance";
import Legal from "./Legal";
import Tagbookings from "./Tagbookings";
import Workordercomments from "./Workordercomments";
import Workorderimages from "./Workorderimages";
import Billingdetails from "./Billingdetails";
import Servicetimeline from "./Servicetimeline";
import Commonmodal from "../../common/Commonmodal";
import Paymentdetails from "./Paymentdetails";
import toast from "react-hot-toast";
import Servicetimelinesummary from "./Servicetimelinesummary";
import Assignagent from "./Assignagent";
import VendorTagging from "./vendortagging";
import { getBlockedVehicleExtensionDetails } from "../../api/api";
import commonapihandler from "../../common/commonapihandler";
import Fieldscommonmodal from "../../common/Fieldscommonmodal";
import moment from "moment";
import fileUpload from "../../common/fileupload";
import Laborcost from "./Laborcost";
import Servicelogbillestimation from "./Servicelogbillestimation";
import Clutchdetails from "./Clutchdetails";
import Timelinewearandtear from "./Timelinewearandtear";
import Tyresdetails from "./Tyresdetails";
import Batterydetails from "./Batterydetails";
import Wheelalignmentdetails from "./Wheelalignmentdetails";
import Windshielddetails from "./Windshielddetails";

const Vieworderdetails = ({
  selectedRow,
  setOpenTab,
  helpdeskTicketPriority,
  workorderType,
  getAllIssues,
  workorderTypeValues,
}) => {
  const orderId = new URLSearchParams(window.location.search).get("orderid");
  const vehicleBlockType = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.vehicleBlockType;
  const profile = JSON.parse(localStorage.getItem("profile"));
  const workorderStatus = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.workorderStatus;
  const vendorTypes = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.vendorTypes;
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  let token = localStorage.getItem("token");
  const [activeTab, setActiveTab] = useState("summary");
  const [workOrderDetail, setWorkOrderDetail] = useState({});
  const [workOrderDetailBlock, setWorkOrderDetailBlock] = useState(null);
  const [openImageModal, setImageModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [creationType, setCreationType] = useState({
    type: "new",
    id: null,
  });
  const [timeLineData, setTimeLineData] = useState([]);
  const [billingDetails, setBillingDetails] = useState(null);
  const [form, setForm] = useState({
    currentOdometer: null,
  });
  const [openModal, setOpenModal] = useState(false);
  const [blockedVehciles, setBlockedVehicles] = useState([]);
  const [editType, setEditType] = useState(null);
  const [firstLoading, setFirstLoading] = useState(false);
  const [error, setError] = useState("");
  const [affectedBookings, setAffectedBookings] = useState([]);
  const [blockedVehicleExtensionData, setBlockedVehicleExtensionData] =
    useState(null);
  const [vendorDetails, setVendorDetails] = useState([]);
  const [taggedVendors, setTaggedVendors] = useState([]);

  const vehicleDetailsBlockExtensionFields = [
    {
      label: "Start Date",
      value: "startdate",
      type: "date",
      disabled: false,
      subCategory: null,
    },
    {
      label: "Start Time",
      value: "starttime",
      type: "time",
      disabled: false,
      subCategory: null,
    },
    {
      label: "End Date",
      value: "enddate",
      type: "date",
      disabled: false,
      subCategory: null,
    },
    {
      label: "End Time",
      value: "endtime",
      type: "time",
      disabled: false,
      subCategory: null,
    },
    {
      label: "Vehicle",
      value: "vehicle",
      type: "text",
      disabled: true,
      subCategory: null,
    },
    {
      label: "Current Odometer",
      value: "currentOdometer",
      type: "number",
      disabled: false,
      subCategory: null,
    },
    {
      label: "Block Type",
      value: "blocktype",
      type: "dropdown",
      disabled: false,
      subCategory: Object.entries(vehicleBlockType).map(([key, value]) => ({
        value: value,
        item: key,
      })),
    },
    {
      label: "Comment",
      value: "comment",
      type: "text",
      disabled: false,
      subCategory: null,
    },
    {
      label: "Upload Image",
      value: "uploadImage",
      type: "file",
      disabled: false,
      subCategory: null,
    },
  ];

  const [tasks, setTasks] = useState([
    {
      description: "",
      panelDetails: "",
      attachements: [],
      cost: "",
      laborCost: "",
      sgstAmount: "",
      sgstPercentage: "",
      cgstAmount: "",
      cgstPercentage: "",
      totalTaxPercentage: "",
      discountAmount: "",
      discountPercentage: "",
    },
  ]);
  const [labours, setLabours] = useState([
    {
      labourCount: "",
      serviceAmount: "",
      description: "",
      discountAmount: "",
      discountPercentage: "",
      sgstAmount: "",
      sgstPercentage: "",
      cgstAmount: "",
      cgstPercentage: "",
      totalTaxPercentage: "",
      totalTaxAmount: "",
      totalAmount: "",
      attachements: [],
    },
  ]);
  const [vehicleTaskDetails, setVehicleTaskDetails] = useState([]);
  const [vehicleServicePartDetails, setVehicleServicePartDetails] = useState(
    [],
  );
  const [serviceBillDetails, setBillDetailsDetails] = useState([]);
  const [serviceLabourCost, setServiceLabourCost] = useState([]);
  const [paymentDetails, setPaymentDetails] = useState(null);
  const [partservice, setPartService] = useState([
    {
      partName: null,
      partNumber: null,
      actionOnPart: null,
      quantity: null,
      unitPrice: null,
      discountAmount: "",
      discountPercentage: "",
      sgstAmount: "",
      sgstPercentage: "",
      cgstAmount: "",
      cgstPercentage: "",
      totalTaxPercentage: "",
      laborCost: null,
      totalCost: null,
      warrantyExpiryDate: null,
      attachments: [],
    },
  ]);
  const [bulkPartservice, setBulkPartService] = useState([
    {
      partName: null,
      partNumber: null,
      actionOnPart: null,
      quantity: null,
      unitPrice: null,
      laborCost: null,
      totalCost: null,
      warrantyExpiryDate: null,
      attachments: [],
    },
  ]);
  const [insurance, setInsurance] = useState([
    {
      insuranceId: null,
      insuranceCompany: null,
      amountClaimed: null,
      amountDispersed: null,
      claimDate: null,
      dispersedDate: null,
    },
  ]);
  const [insuranceDetails, setInsuranceDetails] = useState([]);
  const [taggedBookings, setTaggedBookings] = useState([]);
  const [insurancePostReponse, setInsurancePostResponse] = useState();
  const [serviceBillData, setServiceBillData] = useState([
    {
      estimationAmount: null,
      description: null,
      attachements: null,
      labourCost: null,
      taxPercentage: null,
      cgstPercentage: null,
      cgstAmount: null,
      sgstPercentage: null,
      sgstAmount: [],
      taxAmount: null,
      discountPercentage: null,
      discountAmount: null,
    },
  ]);

  const getBlockedVehicleExtensionDetailsAPI = async (id) => {
    const apiDetails = await getBlockedVehicleExtensionDetails(id);
    const response = await commonapihandler(
      apiDetails?.apiUrl,
      apiDetails?.method,
    );
    if (response?.statusCode === "0100") {
      setBlockedVehicleExtensionData(response?.entities?.rows);
    }
  };

  const handleImageClose = () => {
    setSelectedImage(null);
    setImageModal(false);
  };

  const handleImageOpen = (url) => {
    setSelectedImage(url);
    setImageModal(true);
  };

  const tabs = [
    { id: "summary", label: "Summary" },
    { id: "assignagent", label: "Assign Agent" },
    ...(workOrderDetail?.subType === "Clutch"
      ? [{ id: "clutchdetails", label: "Clutch Details" }]
      : []),
    ...(workOrderDetail?.subType === "Tyres"
      ? [{ id: "tyredetails", label: "Tyre Details" }]
      : []),
    ...(workOrderDetail?.subType === "Battery"
      ? [{ id: "batterydetails", label: "Battery Details" }]
      : []),
    ...(workOrderDetail?.subType === "Wheel Alignment / Balancing"
      ? [{ id: "wheeldetails", label: "Wheel Details" }]
      : []),
    ...(workOrderDetail?.subType === "Wind Shield"
      ? [{ id: "windshielddetails", label: "Wind Shield Details" }]
      : []),

    ...([
      Number(workorderStatus?.inverted?.billingApproved),
      Number(workorderStatus?.inverted?.serviceCompleted),
      Number(workorderStatus?.inverted?.enrouteToHub),
      Number(workorderStatus?.inverted?.enrouteToGarage),
      Number(workorderStatus?.inverted?.open),
    ].includes(Number(workOrderDetail?.serviceStatus)) ||
    workOrderDetail?.serviceType === Number(workorderType?.inverted?.wearAndTear)
      ? []
      : [
          { id: "parts", label: "Part Details" },
          { id: "vehicleservicetasks", label: "Vehicle Service Tasks" },
          { id: "vehicleservicelaborCost", label: "Service Labor Cost" },
          // { id: "servicebillestimation", label: "Service Bill Estimation" },
        ]),

    { id: "accident", label: "Legal Info" },
    { id: "tagbookings", label: "Tag Bookings" },
    { id: "vendortagging", label: "Vendor Taggings" },
    { id: "insurance", label: "Insurance" },
    { id: "comments", label: "Comments" },
    { id: "images", label: "Images" },

    ...([
      Number(workorderStatus?.inverted?.inProgress),
      Number(workorderStatus?.inverted?.billingApproved),
      Number(workorderStatus?.inverted?.billingApprovalRequest),
      Number(workorderStatus?.inverted?.completed),
      Number(workorderStatus?.inverted?.billingRequestRejected),
      Number(workorderStatus?.inverted?.serviceCompleted),
    ].includes(Number(workOrderDetail?.serviceStatus))
      ? [{ id: "billingdetails", label: "Billing Details" }]
      : []),

    // ...([
    //   Number(workorderStatus?.inverted?.billingApproved),
    //   Number(workorderStatus?.inverted?.completed),
    //   Number(workorderStatus?.inverted?.serviceCompleted),
    // ].includes(Number(workOrderDetail?.serviceStatus))
    //   ? [{ id: "paymentdetails", label: "Payment Details" }]
    //   : []),
    { id: "paymentdetails", label: "Payment Details" },
    { id: "serviceTimeline", label: "Timeline" },
    { id: "serviceTimelinesummary", label: "Service TImeline Summary" },
  ];

  const getPaymentDetails = async (id) => {
    if (!token) {
      return toast.error("Session Expired Close all the tab and signin again");
    }
    try {
      const response = await fetch(
        `${apiUrl}/api/servicelogpaymenttransactions?serviceLogId=${id}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `${token}`,
          },
        },
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setPaymentDetails(data?.entities?.rows);
      } else {
        toast.error(data?.msg);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching Hub Names:", error);
    }
  };

  const getWorkOrderDetails = async (id) => {
    try {
      const response = await fetch(`${apiUrl}/api/vehicleservices/${id}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `${token}`,
        },
      });
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setWorkOrderDetail(data?.entityValue);
        await getVendorDetails(data?.entityValue?.cityId);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching get vehicle listings:", error);
    }
  };

  const getWorkOrderDetailsBlock = async (id) => {
    try {
      const response = await fetch(
        `${apiUrl}/api/blockedvehicles?serviceLogId=${id}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `${token}`,
          },
        },
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setWorkOrderDetailBlock(data?.entities?.rows[0]);
        await getBlockedVehicleExtensionDetailsAPI(data?.entities?.rows[0]?.id);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching get vehicle listings:", error);
    }
  };

  useEffect(() => {
    if (selectedRow?.id || orderId) {
      const id = selectedRow?.id || orderId;
      getWorkOrderDetails(id);
      getVehicleTaskDetails(id);
      getVehicleServicePartDetails(id);
      getTaggedBookings(id);
      getPaymentDetails(id);
      getTimeLIneDataDetails(id);
      getWorkOrderDetailsBlock(id);
      getBillingDetails(id);
      getSelectedVendor(id);
      getServiceLabourDetails(id);
      getServiceBillDetails(id);
    }
  }, [selectedRow, orderId]);

  const getBillingDetails = async (id) => {
    if (!token) {
      return toast.error("Session Expired Close all the tab and signin again");
    }
    try {
      const response = await fetch(
        `${apiUrl}/api/servicelogbillingdetails?serviceLogId=${id}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `${token}`,
          },
        },
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setBillingDetails(data?.entities?.rows[0]);
      } else {
        toast.error(data?.msg);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching Hub Names:", error);
    }
  };

  const getVehicleTaskDetails = async (id) => {
    try {
      const response = await fetch(
        `${apiUrl}/api/vehicleservicetasks?isArchived=${false}&limit=${300}&logId=${id}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `${token}`,
          },
        },
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setVehicleTaskDetails(data?.entities?.rows);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching get vehicle listings:", error);
    }
  };

  const getServiceLabourDetails = async (id) => {
    try {
      const response = await fetch(
        `${apiUrl}/api/laborservices?isArchived=${false}&limit=${300}&serviceLogId=${id}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `${token}`,
          },
        },
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setServiceLabourCost(data?.entities?.rows);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching get vehicle listings:", error);
    }
  };

  const getServiceBillDetails = async (id) => {
    try {
      const response = await fetch(
        `${apiUrl}/api/servicelogbillestimations?isArchived=${false}&limit=${300}&logId=${id}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `${token}`,
          },
        },
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setBillDetailsDetails(data?.entities?.rows);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching get vehicle listings:", error);
    }
  };

  const getVehicleServicePartDetails = async (id) => {
    try {
      const response = await fetch(
        `${apiUrl}/api/vehicleserviceparts?isArchived=${false}&limit=${300}&logId=${id}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `${token}`,
          },
        },
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setVehicleServicePartDetails(data?.entities?.rows);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching get vehicle listings:", error);
    }
  };

  const getTaggedBookings = async (id) => {
    try {
      const response = await fetch(
        `${apiUrl}/api/vehicleservicetaggedbookings?serviceId=${id}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `${token}`,
          },
        },
      );

      const data = await response.json();

      if (data?.statusCode === "0100") {
        setTaggedBookings(data?.entities?.rows || []);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const getTimeLIneDataDetails = async (id) => {
    try {
      const res = await fetch(
        `${apiUrl}/api/servicetimelines?serviceLogId=${id}`,
        {
          headers: { Authorization: token },
        },
      );
      const data = await res.json();

      if (data?.statusCode === "0100") {
        setTimeLineData(data.entities.rows || []);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const getVendorDetails = async (id) => {
    if (!token) {
      return toast.error("Session Expired Close all the tab and signin again");
    }
    try {
      const response = await fetch(
        `${apiUrl}/api/vendors?vendorType=${vendorTypes?.inverted?.service}&cityId=${id}&limit=1000&page=0`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `${token}`,
          },
        },
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setVendorDetails(data?.entities?.rows);
      } else {
        toast.error(data?.msg);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching Hub Names:", error);
    }
  };

  const getSelectedVendor = async (id) => {
    if (!token) {
      return toast.error("Session Expired Close all the tab and signin again");
    }
    try {
      const response = await fetch(
        `${apiUrl}/api/vehicleservicevendors?serviceLogId=${id}&vendorTypes=${vendorTypes?.inverted?.service}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `${token}`,
          },
        },
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setTaggedVendors(data?.entities?.rows || []);
      } else {
        toast.error(data?.msg);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching Hub Names:", error);
    }
  };

  const handleModalClose = () => {
    setForm({
      currentOdometer: null,
    });
    setOpenModal(false);
    setBlockedVehicles([]);
    setError("");
  };

  const handleModalOpen = () => {
    setOpenModal(true);
  };

  const getaffectedBlockings = async () => {
    try {
      const response = await fetch(
        `${apiUrl}/api/blockedvehicles/blocklistbyvehicle?vehicleId=${workOrderDetail?.vehicleId}&startDate=${
          form?.startdate + "T" + form?.starttime
        }&endDate=${form?.enddate + "T" + form?.endtime}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `${token}`,
          },
        },
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setBlockedVehicles(data?.dataValues);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching Affected Bookings:", error);
    }
  };

  const UpdateVehicleDetails = async () => {
    if (blockedVehciles?.length > 0) {
      return toast?.error(
        "Already this vehicle is blocked on the specific duration",
        {
          position: "bottom-center",
          style: {
            background: "white", // override background
            color: "red",
            fontWeight: "medium",
            marginBottom: "50px",
          },
        },
      );
    }
    try {
      const response = await fetch(`${apiUrl}/api/blockvehicleextns`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify({
          blockId: workOrderDetailBlock?.id,
          blocktype: form?.blocktype,
          oldEndDate: moment(workOrderDetailBlock?.endDate).format(
            "YYYY-MM-DDTHH:mm",
          ),
          newStartDate: form?.startdate + "T" + form?.starttime,
          newEndDate: form?.enddate + "T" + form?.endtime,
          reason: form?.comment,
          attachments: JSON.stringify(form?.uploadImage),
          extByName: profile?.name,
          extByEmail: profile?.email,
          extBy: profile?.id,
        }),
      });
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setForm({
          currentOdometer: null,
        });
        setOpenModal(false);
        toast.success("Vehicle Changes Updated successfully.", {
          position: "bottom-center",
          style: {
            background: "blue", // override background
            color: "white",
            fontWeight: "medium",
            marginBottom: "50px",
          },
        });
        await getBlockedVehicleExtensionDetailsAPI(workOrderDetailBlock?.id);
      } else {
        toast.error(data?.msg);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching POST vehicle details:", error);
    }
  };

  const handleChange = async (field, value) => {
    if (field === "uploadImage") {
      await fileUpload(value, "vehicles", "vehicle").then((res) => {
        setForm((prev) => ({
          ...prev,
          [field]: res || "",
        }));
      });
      return;
    }

    setForm((prev) => {
      const nextForm = { ...prev, [field]: value };

      if (field === "startdate" || field === "starttime") {
        nextForm.enddate = "";
        nextForm.endtime = "";
      }

      return nextForm;
    });
  };

  const getaffectedbookings = async () => {
    try {
      const response = await fetch(
        `${apiUrl}/api/bookings/getbookingbydates?startDate=${
          form?.startdate + "T" + form?.starttime
        }&endDate=${form?.enddate + "T" + form?.endtime}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        },
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        const filtered = data?.dataValues?.filter(
          (item) =>
            String(item.vehicleId) === String(workOrderDetail?.vehicleId),
        );
        setAffectedBookings(filtered);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching Affected Bookings:", error);
    }
  };

  useEffect(() => {
    if (form?.startdate && form?.starttime && form?.enddate && form?.endtime) {
      getaffectedbookings();
      getaffectedBlockings();
    }
  }, [form?.endtime]);

  useEffect(() => {
    const endDateTime = workOrderDetailBlock?.endDate;

    const enddate = endDateTime ? endDateTime.split(" ")[0] : "";
    const endtime = endDateTime ? endDateTime.split(" ")[1]?.slice(0, 5) : "";

    setForm({
      currentOdometer: workOrderDetail?.odometerReading || "",
      // status: vehicleData?.status || "",
      vehicle: workOrderDetailBlock?.name || "",
      startdate: enddate,
      starttime: endtime,
    });
  }, [openModal]);

  return (
    <>
      {openModal && (
        <>
          <Fieldscommonmodal
            open={openModal}
            onClose={handleModalClose}
            textfields={
              editType === "block extension"
                ? vehicleDetailsBlockExtensionFields
                : ""
            }
            UpdateVehicleDetails={UpdateVehicleDetails}
            form={form}
            handleChange={handleChange}
            setForm={setForm}
            selectedRow={selectedRow}
            error={error}
            affectedBookings={affectedBookings}
            blockedVehciles={blockedVehciles}
          />
        </>
      )}

      {openImageModal && (
        <>
          <Commonmodal
            open={handleImageOpen}
            onClose={handleImageClose}
            url={selectedImage}
          />
        </>
      )}

      <div className="p-6">
        <div className="flex justify-between items-center mb-4">
          <h1 className="text-2xl font-bold mb-4">
            WorkOrder Detail - {workOrderDetail?.serviceCode} -{" "}
            <span className="bg-yellow-600 p-3 rounded-lg text-white text-sm">
              {workOrderDetail?.subType || "-"}
            </span>
            <span className="my-4 text-lg font-bold mx-4 bg-gray-100 inline-block px-3 py-1 rounded">
              {workorderStatus[workOrderDetail?.serviceStatus]}
            </span>
          </h1>

          <div className="flex gap-2">
            {workOrderDetail?.serviceStatus !==
              Number(workorderStatus?.inverted?.serviceCompleted) && (
              <div className="mt-2">
                <button
                  onClick={() => {
                    setOpenModal(true);
                    setEditType("block extension");
                  }}
                  className="px-5 py-2 rounded-lg bg-blue-600 text-white hover:bg-blue-700"
                >
                  Block Extension
                </button>
              </div>
            )}
            <button
              className="bg-white text-center w-56 rounded-2xl h-14 relative text-black text-xl font-semibold group"
              type="button"
              onClick={() => {
                setOpenTab(false);
                getAllIssues();
                window.history.replaceState({}, "", window.location.pathname);
              }}
            >
              <div className="bg-green-400 rounded-xl h-12 w-1/4 flex items-center justify-center absolute left-1 top-[4px] group-hover:w-[194px] z-10 duration-500">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 1024 1024"
                  height="25px"
                  width="25px"
                >
                  <path
                    d="M224 480h640a32 32 0 1 1 0 64H224a32 32 0 0 1 0-64z"
                    fill="#000000"
                  />
                  <path
                    d="m237.248 512 265.408 265.344a32 32 0 0 1-45.312 45.312l-288-288a32 32 0 0 1 0-45.312l288-288a32 32 0 1 1 45.312 45.312L237.248 512z"
                    fill="#000000"
                  />
                </svg>
              </div>
              <p className="translate-x-2">Go Back</p>
            </button>
          </div>
        </div>

        <div className="flex gap-4">
          <div className="w-48 bg-white shadow-md rounded-xl p-2 h-full">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`w-full text-left px-4 py-3 rounded-lg mb-2 text-sm font-medium transition-all duration-200 ${
                  activeTab === tab.id
                    ? "bg-blue-600 text-white"
                    : "hover:bg-gray-100"
                }`}
              >
                {tab.label}
              </button>
            ))}
          </div>

          <div className="flex-1 bg-gray-100 shadow-md rounded-xl p-5 h-screen overflow-y-scroll scrollbar-hide">
            {activeTab === "summary" && (
              <Workordersummary
                workOrderDetail={workOrderDetail}
                workorderType={workorderType}
                helpdeskTicketPriority={helpdeskTicketPriority}
                setCreationType={setCreationType}
                setTasks={setTasks}
                vehicleTaskDetails={vehicleTaskDetails}
                setActiveTab={setActiveTab}
                vehicleServicePartDetails={vehicleServicePartDetails}
                taggedBookings={taggedBookings}
                handleImageOpen={handleImageOpen}
                paymentDetails={paymentDetails}
                billingDetails={billingDetails}
                setPartService={setPartService}
                workOrderDetailBlock={workOrderDetailBlock}
                blockedVehicleExtensionData={blockedVehicleExtensionData}
                getVehicleServicePartDetails={getVehicleServicePartDetails}
                getVehicleTaskDetails={getVehicleTaskDetails}
                taggedVendors={taggedVendors}
                vendorDetails={vendorDetails}
                serviceLabourCost={serviceLabourCost}
                setLabours={setLabours}
                getServiceLabourDetails={getServiceLabourDetails}
                workorderTypeValues={workorderTypeValues}
                getWorkOrderDetails={getWorkOrderDetails}
              />
            )}

            {activeTab === "assignagent" && (
              <>
                <Assignagent workOrderDetail={workOrderDetail} />
              </>
            )}

            {activeTab === "allIssues" && (
              <>
                <Issuesinorder workOrderDetail={workOrderDetail} />
              </>
            )}

            {activeTab === "vehicleservicetasks" && (
              <>
                <Vehicleservicetasks
                  workOrderDetail={workOrderDetail}
                  setCreationType={setCreationType}
                  creationType={creationType}
                  tasks={tasks}
                  setTasks={setTasks}
                  vehicleTaskDetails={vehicleTaskDetails}
                  setVehicleTaskDetails={setVehicleTaskDetails}
                  setActiveTab={setActiveTab}
                  getVehicleTaskDetails={getVehicleTaskDetails}
                  handleImageOpen={handleImageOpen}
                />
              </>
            )}

            {activeTab === "vehicleservicelaborCost" && (
              <>
                <Laborcost
                  workOrderDetail={workOrderDetail}
                  setCreationType={setCreationType}
                  creationType={creationType}
                  labours={labours}
                  setLabours={setLabours}
                  serviceLabourCost={serviceLabourCost}
                  setServiceLabourCost={setServiceLabourCost}
                  setActiveTab={setActiveTab}
                  getVehicleTaskDetails={getVehicleTaskDetails}
                  handleImageOpen={handleImageOpen}
                  getServiceLabourDetails={getServiceLabourDetails}
                />
              </>
            )}

            {activeTab === "servicebillestimation" && (
              <>
                <Servicelogbillestimation
                  workOrderDetail={workOrderDetail}
                  setCreationType={setCreationType}
                  creationType={creationType}
                  serviceBillData={serviceBillData}
                  setServiceBillData={setServiceBillData}
                  serviceBillDetails={serviceBillDetails}
                  setBillDetailsDetails={setBillDetailsDetails}
                  setActiveTab={setActiveTab}
                  getVehicleTaskDetails={getVehicleTaskDetails}
                  handleImageOpen={handleImageOpen}
                  getServiceBillDetails={getServiceBillDetails}
                />
              </>
            )}

            {activeTab === "parts" && (
              <>
                <Vehicleservicepartdetails
                  workOrderDetail={workOrderDetail}
                  setCreationType={setCreationType}
                  creationType={creationType}
                  partservice={partservice}
                  setPartService={setPartService}
                  vehicleServicePartDetails={vehicleServicePartDetails}
                  setVehicleServicePartDetails={setVehicleServicePartDetails}
                  setActiveTab={setActiveTab}
                  getVehicleServicePartDetails={getVehicleServicePartDetails}
                  handleImageOpen={handleImageOpen}
                  setBulkPartService={setBulkPartService}
                  bulkPartservice={bulkPartservice}
                />
              </>
            )}

            {activeTab === "clutchdetails" && (
              <>
                <Clutchdetails
                  handleImageOpen={handleImageOpen}
                  workOrderDetail={workOrderDetail}
                />
              </>
            )}

            {activeTab === "tyredetails" && (
              <>
                <Tyresdetails workOrderDetail={workOrderDetail} />
              </>
            )}

            {activeTab === "batterydetails" && (
              <>
                <Batterydetails workOrderDetail={workOrderDetail} />
              </>
            )}

            {activeTab === "wheeldetails" && (
              <>
                <Wheelalignmentdetails workOrderDetail={workOrderDetail} />
              </>
            )}

            {activeTab === "windshielddetails" && (
              <>
                <Windshielddetails workOrderDetail={workOrderDetail} />
              </>
            )}

            {activeTab === "tagbookings" && (
              <>
                <Tagbookings
                  workOrderDetail={workOrderDetail}
                  getTaggedBookings={getTaggedBookings}
                  setTaggedBookings={setTaggedBookings}
                  taggedBookings={taggedBookings}
                  handleImageOpen={handleImageOpen}
                />
              </>
            )}

            {activeTab === "insurance" && (
              <>
                <Insurance
                  handleImageOpen={handleImageOpen}
                  workOrderDetail={workOrderDetail}
                  insurancePostReponse={insurancePostReponse}
                  setInsurancePostResponse={setInsurancePostResponse}
                />
              </>
            )}

            {activeTab === "comments" && (
              <>
                <Workordercomments
                  handleImageOpen={handleImageOpen}
                  workOrderDetail={workOrderDetail}
                />
              </>
            )}

            {activeTab === "vendortagging" && (
              <>
                <VendorTagging
                  workOrderDetail={workOrderDetail}
                  getVendorDetails={getVendorDetails}
                  vendorDetails={vendorDetails}
                  taggedVendors={taggedVendors}
                  setTaggedVendors={setTaggedVendors}
                  setVendorDetails={setVendorDetails}
                  getSelectedVendor={getSelectedVendor}
                />
              </>
            )}

            {activeTab === "images" && (
              <>
                <Workorderimages
                  selectedRow={selectedRow}
                  workOrderDetail={workOrderDetail}
                  handleImageOpen={handleImageOpen}
                />
              </>
            )}

            {activeTab === "billingdetails" && (
              <>
                <Billingdetails
                  selectedRow={selectedRow}
                  workOrderDetail={workOrderDetail}
                  handleImageOpen={handleImageOpen}
                  taggedBookings={taggedBookings}
                  getBillingDetails={getBillingDetails}
                  billingDetails={billingDetails}
                  setBillingDetails={setBillingDetails}
                />
              </>
            )}

            {activeTab === "accident" && (
              <>
                <Legal
                  workOrderDetail={workOrderDetail}
                  getTaggedBookings={getTaggedBookings}
                  setTaggedBookings={setTaggedBookings}
                  taggedBookings={taggedBookings}
                  handleImageOpen={handleImageOpen}
                />
              </>
            )}

            {activeTab === "serviceTimeline" &&
            workorderTypeValues[workOrderDetail?.serviceType] ===
              "Wear And Tear" ? (
              <>
                <Timelinewearandtear
                  selectedRow={selectedRow}
                  workOrderDetail={workOrderDetail}
                  getWorkOrderDetails={getWorkOrderDetails}
                  vehicleTaskDetails={vehicleTaskDetails}
                  vehicleServicePartDetails={vehicleServicePartDetails}
                  serviceLabourCost={serviceLabourCost}
                  insurancePostReponse={insurancePostReponse}
                  handleImageOpen={handleImageOpen}
                  timeLineData={timeLineData}
                  setTimeLineData={setTimeLineData}
                />
              </>
            ) : (
              activeTab === "serviceTimeline" && (
                <>
                  <Servicetimeline
                    selectedRow={selectedRow}
                    workOrderDetail={workOrderDetail}
                    getWorkOrderDetails={getWorkOrderDetails}
                    vehicleTaskDetails={vehicleTaskDetails}
                    vehicleServicePartDetails={vehicleServicePartDetails}
                    serviceLabourCost={serviceLabourCost}
                    insurancePostReponse={insurancePostReponse}
                    handleImageOpen={handleImageOpen}
                    timeLineData={timeLineData}
                    setTimeLineData={setTimeLineData}
                  />
                </>
              )
            )}

            {activeTab === "paymentdetails" && (
              <>
                <Paymentdetails
                  workOrderDetail={workOrderDetail}
                  paymentDetails={paymentDetails}
                  setPaymentDetails={setPaymentDetails}
                  getPaymentDetails={getPaymentDetails}
                  getWorkOrderDetails={getWorkOrderDetails}
                  billingDetails={billingDetails}
                />
              </>
            )}

            {activeTab === "serviceTimelinesummary" && (
              <>
                <Servicetimelinesummary data={timeLineData} />
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Vieworderdetails;
